<template>
  <div class="main-okved-dadata">
    <a href="#" class="dadata-okved-modal-link" @click.prevent="onShowModal">{{
      mainOkvedText
    }}</a>
    <v-dialog v-model="showDialog" width="777" content-class="okved-modal">
      <v-layout row wrap modal>
        <span class="modal__close" @click="onCloseModal"></span>
        <v-card class="scroll-y" max-height="80vh">
          <v-card-title class="headline">{{ titleModal }}</v-card-title>
          <v-card-text>
            <table class="table-okved-list">
              <tbody>
                <tr
                  v-for="okvedItem in dadata.okveds"
                  :key="okvedItem.code"
                  :class="okvedItem.main ? 'main' : 'not-main'"
                >
                  <td>{{ okvedItem.code }}</td>
                  <td>{{ okvedItem.name }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>

import i18n from "@/services/i18n";

export default {
  name: "DadataOkved",
  data: () => ({
    showDialog: false,
  }),
  props: {
    dadata: {
      type: Object,
    },
    titleModal: {
      type: String,
      default: i18n.t('components.dadata.okved.title'),
    },
  },
  computed: {
    mainOkvedText() {
      if (!this.dadata) return null;
      if (!this.dadata.okveds) return this.dadata.okved;
      return this.dadata.okveds[0].code + " - " + this.dadata.okveds[0].name;
    },
  },

  methods: {
    onShowModal() {
      this.showDialog = true;
    },
    onCloseModal() {
      this.showDialog = false;
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.okved-modal {
  overflow: inherit;
  > .layout {
    position: relative;
    > span.modal__close {
      left: -40px;
    }
  }

  .scroll-y {
    overflow-y: auto;
  }

  table.table-okved-list {
    color: black;
    tbody {
      > tr {
        > td {
          text-align: left;
          vertical-align: top;
        }
        &.main {
          font-weight: bold;
        }
      }
    }
  }
}
.main-okved-dadata {
  position: relative;

  a.dadata-okved-modal-link {
    text-decoration: none;
    position: relative;
    color: #7f88f9;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      border-bottom: 1px dashed #7f88f9;
    }
  }
}
</style>
